import styled from 'styled-components';

import Text from 'components/_core/Text';

export const NavigationHeaderWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const ActionsLabel = styled(Text).attrs({ variant: 'light' })`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;
